export default "__VITE_ASSET__dqdKcOl1__"